import React, { useState, useEffect } from 'react';

/**
 * SafeImage ��� wraps <img> to detect unencrypted files via X-File-Unsafe header.
 * Shows a red border + warning overlay if the file is not encrypted on storage.
 * Props: same as <img> (src, alt, style, className, etc.) + onUnsafe callback.
 */
export default function SafeImage({ src, alt, style, className, onUnsafe, ...rest }) {
  const [unsafe, setUnsafe] = useState(false);
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!src) return;
    let revoke = null;

    // Fetch via fetch() to read response headers
    const token = sessionStorage.getItem('token');
    fetch(src, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      credentials: 'include',
    })
      .then(async (res) => {
        if (!res.ok) return;
        if (res.headers.get('x-file-unsafe') === '1') {
          setUnsafe(true);
          onUnsafe?.();
        }
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        revoke = url;
        setBlobUrl(url);
      })
      .catch(() => {});

    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [src]); // eslint-disable-line

  if (!src) return null;

  const wrapperStyle = {
    position: 'relative',
    display: 'inline-block',
    ...(unsafe ? { border: '3px solid #dc2626', borderRadius: 6 } : {}),
  };

  return (
    <span style={wrapperStyle}>
      <img
        src={blobUrl || src}
        alt={alt || ''}
        style={style}
        className={className}
        {...rest}
      />
      {unsafe && (
        <span style={{
          position: 'absolute', top: -8, left: '50%', transform: 'translateX(-50%)',
          background: '#dc2626', color: '#fff', fontSize: 9, fontWeight: 700,
          padding: '1px 6px', borderRadius: 4, whiteSpace: 'nowrap',
        }}>
          Re-upload needed
        </span>
      )}
    </span>
  );
}
